import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { toDinero, toNumberLossy } from "../../../../currency/currencyLib"
import { StatisticGraph } from "../../../../../shared/components/statistic/StatisticGraph"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchPosPurchaseSummary } from "../companyReportsHomeApi"

type StatisticsPosNumberOfTransactionsProps = Readonly<{
    periodInDays: number
}>

export function POSPurchasesStat({ periodInDays }: StatisticsPosNumberOfTransactionsProps) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchPosPurchaseSummary, {
        queryName: CompanyReportsHomeQuery.POS_PURCHASES_SUMMARY,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })

    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.posPurchases.map((entry) => entry.date)}
            datasets={data.posPurchases.map((entry) => toNumberLossy(toDinero(entry.purchaseSummary.totalAmount)))}
            title={data?.reportSummary?.changeInPercentage}
        />
    )
}
